$shm_hitalama_map_widget_float_code_js $shm_hitalama_map_widget_float_code
	textarea_hint \javascript
